import React, { useContext, useState, useEffect } from "react";
import ExpandCommand from "../../Commands/ExpandCommand/ExpandCommand";
import CollapseCommand from "../../Commands/CollapseCommand/CollapseCommand";
import Panel from "../Panel/Panel";
import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";
import useKeyPress from "../../../Hooks/useKeyPress";
import useGetNestedOccurence from "../../../Hooks/useGetNestedOccurence.js";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function ListView(props) {
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const currentToolIds = globalState.state.formData.currentTool.map(item=> item.id);
  const [dragPanelOver, setDragPanelOver] = useState({dropOverId:0, isDragPanelOver: false});
  const getNestedOccurence = useGetNestedOccurence();
  const buildStyle = useBuildStyle();
  const getCurrentTemplateId = () => {
    var n = props.data.metaData.length;
    var id = undefined;
    if (n !== 0)
      id = props.data.metaData.map(item => item.id)[n-1];
    return id;
  };
  const [currentTemplateId, setCurrentTemplateId] = useState(getCurrentTemplateId());
  const CtrlPressed = useKeyPress(17);
  const [isDragOver, setDragover] = useState(false);
  const [isExpanded, setExpanded] = useState(false);
  const padding = 2;
  var currentTemplate = currentTemplateId && props.data.metaData.filter(item => item.id == currentTemplateId)[0];
  
  
  const tabHeaderHeight = parseInt(props.data.styles.fontSize.value.slice(0, -2)) + 4;
  const collapseWidth = props.data.properties.accordion.value ? 20 : 0;

  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);
 
  const onDragStart = (e, template) => {
    e.dataTransfer.setData("tabPanelId", JSON.stringify(template));
    e.stopPropagation();
  };

  const getMarginTop = (top) => {
    return top - tabHeaderHeight -padding;
  };

  const onTemplateClick = (e, template, current) => {
    if (current.id == template.id) {
      onClick(e, template)
      setCurrentTemplateId(template.id);
    } else props.onClick(e, current)
};

const updateOccurenceValue = (containers, id, data) => {
  if (!containers.metaData) return;
  containers.metaData.map(item => {
    if (id == item.id) {
      item.metaData = data;
      return;
    }
    else
    updateOccurenceValue(item, id, data);
  });
};

/*const getNestedOccurence = (containers, id, metaData) => {
  if (metaData.length != 0) return metaData; 
    containers.metaData.map(container => {
      if (container.id == id) metaData.push(container.metaData);
      getNestedOccurence(container, id, metaData);
    }
  )
};
*/

const onDropPanel = (e, columnDestination) => {

  var dataTransfer = e.dataTransfer.getData("tabPanelId");
  if (dataTransfer){

  var columnSource = JSON.parse(dataTransfer);
  
  var canAdd = columnSource.id !== columnDestination.id 
  && props.data.metaData.map(item=> item.id ).includes(columnSource.id)
  && props.data.metaData.map(item=> item.id ).includes(columnDestination.id)
  
  if (canAdd) {
        var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
       
        var metaData = [];
        
        getNestedOccurence(updatedFormData, props.data.id, metaData);
         
        metaData = metaData.flat(1);

        var destinationIndex = -1;
        metaData.map((val, index) => {
        if (val.id == columnDestination.id) destinationIndex = index;
        });

        metaData = metaData.filter(
        (item) => item.id != columnSource.id
        );
       

        var data = [
        ...metaData.slice(0, destinationIndex),
        ...[columnSource],
        ...metaData.slice(destinationIndex ),
        ]
    

        updateOccurenceValue(updatedFormData, props.data.id, data)
       
        updatedFormData.currentTool = [columnSource];

        dispatch({
          type: "UPDATE_FORM",
          payload: updatedFormData,
        });
  }
}
  setDragPanelOver(false);
  e.stopPropagation();
};

const onClick = (e, template) => {
      
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    var alreadyClick = currentToolIds.includes(template.id);

    if (CtrlPressed.keyPressed == true){
      if (alreadyClick)
        updatedFormData.currentTool = updatedFormData.currentTool.filter(item => item.id != template.id);
      else
        updatedFormData.currentTool.push(template);
    }
    else
      updatedFormData.currentTool = [template];
    dispatch({
      type: "UPDATE_FORM_WITOUT_HISTORIQUE",
      payload: updatedFormData,
    });  
    
  e.stopPropagation();
  
};

  const getTabStyle = (meta) => {
    var newStyle = buildStyle(meta.styles);
    newStyle["position"] = props.position ? props.position : "absolute";
    newStyle.height = parseInt(newStyle.height.slice(0,-2)) + tabHeaderHeight + "px";
    newStyle.top = newStyle.top - tabHeaderHeight -padding;
    newStyle.left = newStyle.left - collapseWidth;
    var isSelected = currentToolIds.includes(meta.id);
    newStyle["border"] = props.draggable && isSelected ? "1px dashed gray" : meta.styles.border.value;
    if (!props.draggable) newStyle["resize"] = "none"
    newStyle["display"] = "flex";
    return newStyle;
  };

  const getPanelStyle = (meta) => {
    var newStyle = JSON.parse(JSON.stringify(meta.styles));
    
    newStyle["width"] = {value:parseInt(props.data.styles.width.value.slice(0,-2))-padding - collapseWidth + "px" };
    newStyle["top"] = {value:tabHeaderHeight + meta.styles.top.value} ;
    
    newStyle["left"] = {value:collapseWidth + meta.styles.left.value}  ;
    var isSelected = currentToolIds.includes(meta.id);
    newStyle["border"] = {value:props.draggable && isSelected ? "1px dashed gray" : meta.styles.border.value};
    
    if (!props.draggable) newStyle["resize"] = "none"
    return newStyle;
  };

  const getCollapseStyle = (meta) => {
    var newStyle = buildStyle(meta.styles);
    newStyle["position"] = props.position ? props.position : "absolute";
    newStyle["width"] = collapseWidth + "px";
    newStyle["height"] = collapseWidth + "px";
    newStyle.top = tabHeaderHeight ;
    newStyle.left = 0;
    delete newStyle.resize;
    delete newStyle.overflow;
    
    return newStyle;
  };
  

  const addPanel = (e) => {
    
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    var template = JSON.parse(JSON.stringify(props.data.panelTemplate));
    /*template["parentId"] = [...props.data.id, ...props.data.parentId];*/
    template["left"] = {value:props.data.left};
    var previousHeight = getPreviousHeight(template.id);
    template["top"] = {value:previousHeight + props.data.top};
    template.styles["top"] = {value:previousHeight};
    props.handleOnDrop(updatedFormData,
      {id:[props.data.id, ...props.data.parentId], globalId:[props.data.globalId, ...props.data.parentGlobalId]}
      //[props.data.id, ...props.data.parentId]
      , template)
    setCurrentTemplateId(template.id);
    e.stopPropagation();
  };

  const getPreviousHeight = () => {    
    var previousHeight = props.data.metaData.reduce((acc, x) => acc + parseInt(x.styles.height.value.slice(0,-2)), 0);      
    return previousHeight;
  };

  const onCollapseClick = () => {    
    setExpanded(!isExpanded)
  };

  const canShow = (collapse) => {    
    return isExpanded || !collapse
  };

  return (
    
  <React.Fragment>
     
    <div   
      id={props.data.id} 
      className="panel"
      draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      onClick={(e)=> onClick(e, props.data)}
      style={getTabStyle(props.data)}> 
        <div style= {getCollapseStyle(props.data)} onClick={()=> onCollapseClick()} >
          <ExpandCommand isShow={!isExpanded} />
          <CollapseCommand isShow={isExpanded} isStandard={false} />
        </div>
        <div>
          {props.data.metaData.map(template =>
          canShow(template.properties.collapse.value) && 
          <Panel 
            data={template}   
            style={getPanelStyle(template)}
            onClick={(e, current)=> onTemplateClick(e, template, current)}
            draggable={props.draggable}
            contextMenus={props.contextMenus}
            onDragStart={(e) => props.onDragStart(e)}
            isTabPanel={true}
            handleOnDrop={(updatedFormData,containerId, template, schema) => 
              props.handleOnDrop(updatedFormData,containerId, template, schema)}
              updateSize ={(id, resizeWidth, resizeHeight) =>  props.updateSize(id, resizeWidth, resizeHeight)}
              onChange={(e, value) => props.onChange(e, value)}
           onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
           //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
           onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
           onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
           onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
            >
          </Panel>
          )}
        </div>
    </div>
    <div  style={{
      display:"flex",
      top: getMarginTop(props.data.styles.top.value),
      left: props.data.styles.left.value + 10,     
      position: "absolute",
      backgroundColor: "transparent" }}>

      <div 
        onClick={(e)=> addPanel(e)}
        style={{
        userSelect: "none",
        lineHeight: tabHeaderHeight + "px",
        marginLeft: "5px",
        marginRight: "5px",
        fontSize: props.data.styles.fontSize.value,
        color: "#cccccc",
        width: "15px",
        fontWeight: "bold",
        cursor: "pointer",
        position: "relative"
        }}>
          +
        </div>
      </div>
    
</React.Fragment>
  );
}
